import React from 'react'
import { Modal, Button } from "react-bootstrap";
import renderHTML from "react-render-html";
export default function ViewModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Report for {props.SelectRepo.monthyear}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <p>
                    {renderHTML(props.SelectRepo.Text)}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}


